import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCourseId } from '../../../store/courseSlice';
import { FormTextField } from '../../common/Form/FormTextField';
import { SIDEKICK_DASHBOARD_PATH } from '../../common/constants';

function DevDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const courseId = useSelector((state) => state.course.courseId);
  const [localCourseId, setLocalCourseId] = useState(courseId ?? '');

  useEffect(() => {
    setLocalCourseId(courseId ?? '');
  }, [courseId]);

  const handleApply = () => {
    dispatch(setCourseId(localCourseId));
    navigate(SIDEKICK_DASHBOARD_PATH);
  };

  return (
    <Box className="mss__devDashboard">
      <Box className="courseIdForm">
        <FormTextField
          id="devDashboard__courseId"
          label="Course ID"
          value={localCourseId}
          onChange={(e) => setLocalCourseId(e.target.value)}
        />
        <Button
          variant="contained"
          className="mss__button primary"
          onClick={handleApply}
          disabled={!localCourseId}
        >
          Apply
        </Button>
      </Box>
    </Box>
  );
}

export default DevDashboard;
